import { PERMISSIONS } from "./permission-registry.ts";
import type { Permission, UserRole } from "./types.ts";

export function can(role: UserRole, permission: Permission) {
  if (!role) return false;

  const allowedRoles = PERMISSIONS[permission];
  if (!allowedRoles) return false;

  return allowedRoles.includes(role);
}

export function canAny(roles: UserRole[], permission: Permission) {
  if (!roles || roles.length === 0) return false;

  const allowedRoles = PERMISSIONS[permission];
  if (!allowedRoles) return false;

  return roles.some((role) => allowedRoles.includes(role));
}
